<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 class="text-center pt-10">
        <v-card class="elevation-0" outlined>
          <v-card-title v-if="tab===0">Login</v-card-title>
          <v-card-title v-else-if="tab===1">Forgot Password</v-card-title>
          <v-card-title v-else-if="tab===2">Reset Password</v-card-title>
          <v-card-title v-else-if="tab===3">Verification Code</v-card-title>
          <v-card-subtitle
            v-if="tab===3"
            class="text-left"
          >An access code has been sent to your registered mobile number</v-card-subtitle>
          <v-card-subtitle
            v-if="tab===2"
            class="text-left"
          >8 characters long, 1 upper, 1 lower and 1 special character</v-card-subtitle>
          <v-card-subtitle
            v-if="tab===1"
            class="text-left"
          >Instructions to reset your password will be sent to your email</v-card-subtitle>
          <v-card-subtitle
            v-if="tab===0"
            class="text-left"
          >Please enter your email and passoword to continue</v-card-subtitle>
          <!-- <offset-heading v-if="tab===0" titleClass="text-sm-center font-weight-bold" title="LOGIN"></offset-heading> -->
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-text class="px-8 py-0">
                <v-form ref="loginForm" lazy-validation>
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    prepend-icon="fas fa-user-circle"
                    label="Email"
                    required
                    aria-autocomplete="current-password"
                    validate-on-blur
                    @keyup.enter="login($event)"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="user.password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    autocomplete="on"
                    hide-details
                    validate-on-blur
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="login($event)"
                  ></v-text-field>
                  <v-layout row wrap class="pt-3">
                    <v-btn
                      @click="tab=1"
                      depressed
                      text
                      class="text-capitalize"
                      color="primary"
                    >Forgot Password?</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn submit color="primary" @click="login($event)">Login</v-btn>
                  </v-layout>
                  <div class="px-5">
                    <v-row>
                      <v-col cols="12" class="py-0">
                        <p class="ma-0">Other Signin Options</p>
                      </v-col>
                      <v-col>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" outlined color="grey" @click="googleAuth">
                              <v-avatar size="18" class="mx-4">
                                <img
                                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"
                                  alt="Login with google"
                                />
                              </v-avatar>
                            </v-btn>
                          </template>
                          <span>Login With Google</span>
                        </v-tooltip>
                        <!-- <div class="g-signin2" data-onsuccess="onSignIn"></div> -->
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text class="px-8 py-0">
                <v-form @submit.prevent ref="forgotPasswordForm" lazy-validation>
                  <v-text-field
                    v-if="showPassResetMessage === null"
                    v-model="user.email"
                    :rules="emailRules"
                    prepend-icon="fas fa-user-circle"
                    label="Email"
                    required
                    aria-autocomplete="current-password"
                    validate-on-blur
                    @keyup.enter="forgotPassword($event)"
                    type="text"
                  ></v-text-field>
                  <div v-else>
                    <p>{{showPassResetMessage}}</p>
                  </div>
                  <v-layout row wrap class="py-4">
                    <v-btn
                      @click="tab=0; showPassResetMessage = null"
                      link
                      text
                      color="primary"
                      class="text-capitalize"
                    >
                      <v-icon small left>fas fa-arrow-left</v-icon>Back to login
                    </v-btn>
                    <v-spacer v-if="showPassResetMessage === null"></v-spacer>
                    <v-btn v-if="showPassResetMessage === null" @click="forgotPassword" color="primary" d-inline-flex>Proceed</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text class="px-8 py-0">
                <v-form @submit.prevent ref="resetPasswordForm" lazy-validation>
                  <v-text-field
                    v-model="resetPassword.password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    name="password"
                    label="New Password"
                    id="reset_password"
                    autocomplete="on"
                    validate-on-blur
                    :append-icon="showResetPassword ? 'visibility_off' : 'visibility'"
                    :type="showResetPassword ? 'text' : 'password'"
                    @click:append="showResetPassword = !showResetPassword"
                  ></v-text-field>
                  <v-text-field
                    v-model="resetPassword.confirm_password"
                    :rules="passwordCheckRules"
                    prepend-icon="lock"
                    name="password"
                    label="Confirm New Password"
                    id="reset_confirm_password"
                    autocomplete="on"
                    validate-on-blur
                    :append-icon="showResetConfirmPassword ? 'visibility_off' : 'visibility'"
                    :type="showResetConfirmPassword ? 'text' : 'password'"
                    @click:append="showResetConfirmPassword = !showResetConfirmPassword"
                  ></v-text-field>
                  <div class="px-5 pb-6 pt-2">
                    <v-layout row wrap justify-center>
                      <!-- <v-spacer></v-spacer> -->
                      <v-btn block @click="handleNewPassword" color="primary" medium>Reset Password</v-btn>
                    </v-layout>
                  </div>
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text class="px-4 py-0">
                <v-form @submit.prevent ref="verifyCodeForm" lazy-validation>
                  <v-text-field
                    autofocus
                    type="number"
                    v-model.number="twoFactor.value"
                    name="code"
                    label="Enter code"
                    hide-details
                  ></v-text-field>
                  <v-layout row wrap class="py-4 pt-6 px-4" align-baseline>
                    <a
                      @click="resendAuthCode"
                      class="primary--text font-weight-medium"
                    >Resend access code</a>
                    <v-spacer></v-spacer>
                    <v-btn @click="verifyAuthCode" color="primary" d-inline-flex>Verify</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <br />
        <!-- <img
          class="pt-3"
          height="80"
          src="../../assets/images/powered.png"
          alt="Powered by Unoapp"
        />-->
      </v-flex>
    </v-layout>
    <v-dialog
      persistent
      eager
      v-model="businessModal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div class="align-v-center cover-bg">
          <v-container grid-list-md text-xs-center>
            <v-layout align-center justify-center row>
              <v-flex sm12 md12>
                <v-card class="elevation-12 pb-4 mt-8">
                  <v-card-title class="primary text-white">
                    ACCOUNTS
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      slot="action"
                      @click="logout()"
                      fab
                      color="white"
                      :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
                    >
                      <v-icon dark class="primary--text">fas fa-sign-out-alt</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-subtitle
                    class="primary white--text"
                  >Select the account that you would like to access</v-card-subtitle>

                  <div class="px-4 mx-1 mt-7 pt-7" v-if="vg_businessesList.length == 0">
                    <p>Sorry you dont have any associated business. Please contact support.</p>
                  </div>
                  <div class="px-4 mx-1 mt-7 pt-7" v-else>
                    <v-layout row wrap justify-space-between>
                      <v-flex
                        px-4
                        sm12
                        xs12
                        md6
                        lg6
                        v-bind:key="index"
                        v-for="(account, index) in vg_businessesList"
                      >
                        <v-card
                          hover
                          class="elevation-12 mb-4 pointer account-list"
                          v-on:click.prevent="setActiveBusiness(account)"
                        >
                          <div class="c-layout">
                            <div class="cl-flex6">
                              <div class="min-h-80 v-center bg-grey">
                                <img src="@/assets/images/uno-logo.png" class="account-logo" />
                              </div>
                            </div>
                            <div class="cl-flex6">
                              <div class="min-h-80 section-excerpt v-center">
                                <h2 class="font-weight-bold title">{{ account.name }}</h2>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AuthAPI } from '../../clients/authclient/auth.api'
const strongPasswordRegex = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')

export default {
  async created () {
    if (!this.$route.params.action) {
      try {
        await AuthAPI.verify()
      } catch (error) {
        console.log(error)
      }
    }
    this.va_clearAuthState()
  },
  async mounted () {
    if (this.$route.params.action) {
      if (this.$route.params.action === 'password_reset') {
        this.tab = 2
      } else if (this.$route.params.action === 'invitation') {
        // handle invitation token
        this.handleInvitation()
      } else if (this.$route.params.action === 'verify_code') {
        this.twoFactor.token = this.$route.query.token
        this.tab = 3
      }
      // hanle action
    } else if (this.$route.query.token && !this.$route.params) {
      this.spinner(true)
      this.va_loginWithToken(this.$route.query.token).then(async (s) => {
        try {
          await this.va_setBusinessesList()
        } catch (error) {
          console.log(error, 'getting business list')
        }
        try {
          await this.setActiveBusiness(s.business)
        } catch (error) {
          console.log(error, 'setting active business')
        }
        this.spinner(false)
      }).catch((e) => {
        console.log(e)
        this.spinner(false)
        return e
      })
    }
    this.spinner(false)
  },
  data () {
    return {
      tab: 0,
      showPassword: false,
      user: {
        email: '',
        password: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => strongPasswordRegex.test(v) || 'Password must be 8 characters long, contain 1 upper , 1 lower and 1 special character'
      ],
      passwordCheckRules: [v => v === this.resetPassword.password || 'Passwords do not match'],
      businessModal: false,
      resetPassword: {
        password: '',
        confirm_password: ''
      },
      showResetPassword: false,
      showResetConfirmPassword: false,
      showPassResetMessage: null,
      twoFactor: {
        status: false,
        value: '',
        token: null
      }
    }
  },
  methods: {
    ...mapActions({
      va_login: 'auth/loginUser',
      va_loginWithToken: 'auth/loginWithToken',
      va_loginWithGoogle: 'auth/loginWithGoogle',
      va_setBusinessesList: 'auth/setUserBusinessesList',
      va_setActiveBusiness: 'auth/setActiveBusiness',
      va_setActiveBusinessBranding: 'auth/setActiveBusinessBranding',
      va_clearAuthState: 'auth/clearState'
    }),
    async login () {
      if (!this.$refs.loginForm.validate()) return
      this.spinner(true)
      try {
        await this.va_login({ email: this.user.email, password: this.user.password })
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      try {
        await this.va_setBusinessesList()
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      this.businessModal = true
      if (this.vg_businessesList.length === 1) {
        this.setActiveBusiness(this.vg_businessesList[0])
      }
      this.spinner(false)
    },
    async googleAuth () {
      this.spinner(true)
      let authCode
      try {
        authCode = await this.$gAuth.getAuthCode()
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      let user
      try {
        user = await this.va_loginWithGoogle(authCode)
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      try {
        await this.va_setBusinessesList()
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      if (this.vg_businessesList.length === 1) {
        this.setActiveBusiness(this.vg_businessesList[0])
      } else {
        this.businessModal = true
      }
      if (this.vg_businessesList.length === 1) {
        this.setActiveBusiness(this.vg_businessesList[0])
      }
      this.spinner(false)
    },
    async setActiveBusiness (business) {
      this.spinner(true)
      let res
      try {
        res = await this.va_setActiveBusiness(business.id)
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }

      if (res.two_factor) {
        this.tab = 3
        this.businessModal = false
        this.spinner(false)
        return
      }

      try {
        await this.va_setActiveBusinessBranding(business.id)
      } catch (error) {
        this.spinner(false)
        console.log(error)
        return this.snackbar({ text: error.response.data.msg })
      }
      this.$vuetify.theme.themes.light.primary = this.vg_activeBusinessBrandingAndLogo.primary
      this.$vuetify.theme.themes.light.secondary = this.vg_activeBusinessBrandingAndLogo.secondary
      this.$vuetify.theme.themes.light.accent = this.vg_activeBusinessBrandingAndLogo.accent
      this.businessModal = false
      this.spinner(false)
    },
    logout () {
      this.va_clearAuthState()
      this.snackbar({ text: 'Logout successful' })
      this.businessModal = false
    },
    async forgotPassword () {
      this.spinner(true)
      let data = {
        email: this.user.email
      }
      let response
      try {
        response = await AuthAPI.requestForgotPassword(data)
        this.spinner(false)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
        console.log(error)
        this.spinner(false)
        return
      }
      this.showPassResetMessage = response.data.msg
      this.spinner(false)
    },
    async resetPass () {
      this.spinner(true)
      let response
      try {
        response = await AuthAPI.resetPassword(this.$route.query.token, this.resetPassword)
        this.spinner(false)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
        console.log(error)
        this.spinner(false)
        return
      }
      this.snackbar({ text: response.data.msg, timeout: 15000 })
      this.resetPassword = {
        password: '',
        confirm_password: ''
      }
      this.tab = 0
      this.spinner(false)
    },
    async handleInvitation () {
      this.spinner(true)
      let response
      try {
        response = await AuthAPI.verifyInvitationToken(this.$route.query.token)
        this.spinner(false)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
        console.log(error)
        this.spinner(false)
        return
      }
      if (response.data.payload.set_new_password) {
        this.snackbar({ text: `${response.data.payload.inviter.first_name} ${response.data.payload.inviter.last_name} wants you to create a new password for ${response.data.payload.business.name}`, timeout: 5000 })
        this.tab = 2
        this.spinner(false)
      } else {
        this.acceptInvitation()
      }
    },
    async handleNewPassword () {
      if (!this.$refs['resetPasswordForm'].validate()) { return }
      if (this.$route.params.action === 'invitation') {
        this.acceptInvitation()
      } else {
        this.resetPass()
      }
    },
    async acceptInvitation () {
      this.spinner(true)
      let acceptInvitation
      try {
        acceptInvitation = await AuthAPI.acceptInvitation(this.$route.query.token, this.resetPassword)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
      }
      this.spinner(false)
      return this.snackbar({ text: acceptInvitation.response.msg })
    },
    async verifyAuthCode () {
      let response
      this.spinner(true)
      try {
        await AuthAPI.verifyAuthCode(this.twoFactor.value, this.twoFactor.token)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
        return this.spinner(false)
      }
      this.spinner(false)
    },
    async resendAuthCode () {
      let response
      this.spinner(true)
      try {
        response = await AuthAPI.resendAuthCode(this.twoFactor.token)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
        return this.spinner(false)
      }
      this.snackbar({ text: response.data.msg, timeout: 7000 })
      this.spinner(false)
    }
  },
  computed: {
    ...mapGetters({
      vg_businessesList: 'auth/businessesList',
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  },
  watch: {},
  beforeDestroy () { }
}
</script>

<style lang="scss" scoped>
.div {
  color: rgb(124, 124, 124);
}
</style>
